import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  private readonly THEME_KEY = 'fogon-theme';
  private isDarkSubject = new BehaviorSubject<boolean>(false);
  isDark$ = this.isDarkSubject.asObservable();

  constructor(@Inject(DOCUMENT) private document: Document) {
    this.loadTheme();
  }

  private loadTheme(): void {
    const saved = localStorage.getItem(this.THEME_KEY);
    if (saved === 'dark') {
      this.setDark(true);
    }
  }

  toggleTheme(): void {
    this.setDark(!this.isDarkSubject.value);
  }

  setDark(dark: boolean): void {
    this.isDarkSubject.next(dark);
    if (dark) {
      this.document.documentElement.setAttribute('data-theme', 'dark');
      localStorage.setItem(this.THEME_KEY, 'dark');
    } else {
      this.document.documentElement.removeAttribute('data-theme');
      localStorage.setItem(this.THEME_KEY, 'light');
    }
  }

  get isDark(): boolean {
    return this.isDarkSubject.value;
  }
}
